module.exports = __webpack_public_path__ + "static/media/hand.857fd79d.png";